import React from 'react'
import './User_LeftPanel.css'

class User_LeftPanel extends React.Component{
    render() {
        return (
            <div className='user-left-panel-container'>
                <div className='user-left-panel-top-buttons-container'>
                </div>
                <div className='user-left-panel-bottom-buttons-container'>
                </div>
            </div>
        );
    }
}

export default User_LeftPanel;
